import { Component, OnInit, AfterViewInit, ViewContainerRef, ViewChild } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/interval';
import 'rxjs/add/operator/takeWhile';
import { ActivatedRoute, Router, ActivatedRouteSnapshot } from '@angular/router';
import { GoogleApiService } from '../../service/google-api.service';
import { map } from 'rxjs/operators';
import { AgGridNg2 } from 'ag-grid-angular';
import { environment, ATADOMAP } from 'environments/environment';


declare const $: any;

@Component({
  selector: 'app-atado-info',
  templateUrl: './atado-info.component.html',
  styleUrls: ['./atado-info.component.css']
})
export class AtadoInfoComponent {

  readonly ATADOMAP = ATADOMAP;
  @ViewChild('agGrid') agGrid: AgGridNg2;

  public title = '';
  public path = '../../fogyaszto';

  rowData: Observable<any>;
  gridApi;
  

  localeText = {
      contains: 'tartalmaz',
      notContains: 'nemTartalmaz',
      startsWith: 'kezdődik',
      endsWith: 'végződik',
      equals: 'egyenlő',
      notEqual: 'nemEgyenlő'
  }

  columnDefs = [
      { headerName: 'Pod', field: 'ngs_pod'},
      { headerName: 'Kereskedő', field: 'szallittato_par_kod', width: 110 },
      { headerName: 'Név', field: 'szerz_foly_meg', width: 150 },
      { headerName: 'Helység', field: 'fogy_helyseg', width: 100 },
      { headerName: 'Utca', field: 'fogy_utca', width: 130, filter: 'agTextColumnFilter', comparator: this.streetComparator},
      { headerName: 'Házszám', field: 'fogy_hazszam', width: 60 },
      { headerName: 'Ir. szám', field: 'fogy_ir_szam', width: 60 },
      { headerName: 'Mérő típusa', field: 'mero_tipusa', width: 100, filter: 'agTextColumnFilter' },
      { headerName: 'Mérő gyártási száma', field: 'mero_gyart_szam', width: 100 },
      { headerName: 'Mérő kapacitás', field: 'mero_kapac', width: 100},
      { headerName: 'Mérési nyomás', field: 'meresi_nyomas', width: 100},
      { headerName: 'Skt', field: 'skt', width: 130, filter:'agNumberColumnFilter'},
      { headerName: 'Átadó', field: 'atado_kod', width: 100 },
      { headerName: 'Tel', field: 'telefonszam', width: 150 }

  ];

  constructor(private googleApi: GoogleApiService, private activatedRoute: ActivatedRoute,
    private router: Router) {
    this.router.routeReuseStrategy.shouldReuseRoute = function() {
      return false;
    };

    this.activatedRoute.params.subscribe(params => {
      console.log('Routed to ' + params.name);
      const getItemProperties = map(value => value['items'].map(elem => elem['properties']));
      this.rowData = this.googleApi.getConsumers(ATADOMAP[params.name]).pipe(getItemProperties);
      this.title = ATADOMAP[params.name];
    });

  }

  onGridReady(params:any){
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
  }

  getSelectedRows() {
    const selectedNodes = this.agGrid.api.getSelectedNodes();
    const selectedData = selectedNodes.map( node => node.data );
    const selectedDataStringPresentation = selectedData.map( node => node.make + ' ' + node.model).join(', ');
    console.log(`Selected nodes: ${selectedDataStringPresentation}`);
  }

  onRowDoubleClicked(event) {
    const ngs_pod = event.data['ngs_pod'];
    console.log('Consumer double clicked, pod:' + ngs_pod);
    window.open(environment.COMPONENTS_ROOT + '/fogyaszto/' + ngs_pod);
  }

  getData(){
    
  }

  dayAllocationForm = false;
  toggleDayAllocationForm(){
    this.dayAllocationForm = true;
  }

  jobFormMode = false;
  toggleJobLogForm(){
    this.jobFormMode = true;
  }

  redirectToConsumerPage(event) {
    console.log(event);
    this.router.navigate(['ngs', 'fogyaszto', event]);
  }

  showNewConsumerButton():boolean {
    return this.title === 'MINYIRTE15GN' || this.title === 'HATELJCS11EN' || this.title === 'HABODONH1VEN';
  }

  showDayAllocationButton():boolean {
    return false;//this.title === 'HABODONH1VEN';
  }

  exportAsCsv(){
    const date = new Date();
    const month = date.getUTCMonth()+1 
    const fileName = this.title + "_" + date.getFullYear() + "_" + month + "_" + date.getDate()
    var params = {
      suppressQuotes: true,
      fileName: fileName,
      columnSeparator: ";"
    };
    this.gridApi.exportDataAsCsv(params);
  }

  streetComparator(street_one, street_two){
    if (street_one === null) {
      return -1;
    }
    if (street_two === null) {
      return 1;
    }
    return street_one.trim().localeCompare(street_two.trim(),'hu');
  }

}



// WEBPACK FOOTER //
// /Users/pkovacs/Documents/Development/ngsAlpha/ngs_alpha_ui/src/app/components/atado-info/atado-info.component.ts